import { render, staticRenderFns } from "./RegInstitution.vue?vue&type=template&id=d5604f18&"
import script from "./RegInstitution.vue?vue&type=script&lang=js&"
export * from "./RegInstitution.vue?vue&type=script&lang=js&"
import style0 from "./RegInstitution.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports